import { createTheme, buttonClasses } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#572E88',
    },
    secondary: {
      main: '#FF0050',
    },
    shade: {
      main: 'rgb(217, 207, 228)',
    },
    gold: { main: '#EAB308' },
    error: { main: '#DC2626' },
    success: { main: '#059669', light: '#E8FAF5' },
    warning: { main: '#F59E0B' },
    fire: { main: '#F97316' },
    whatsapp: { main: '#25D366' },
    text: {
      primary: '#1F1333',
      secondary: '#625A70',
      disabled: '#8C8494',
    },
    divider: '#E2DFE8',
  },
  typography: {
    fontFamily: [
      'Inter',
      'Gotham Book',
      'Gotham Rounded Bold',
      '-apple-system',
      'BlinkMacSystemFont',
      'sans-serif',
    ].join(','),
  },
  fontSizes: {
    title: '18px', // main headings, course name
    subtitle: '15px', // user name, section headers
    body: '14px', // item text, labels, text buttons
    caption: '12px', // secondary info: duration, greeting, streak days
  },
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          [`&.${buttonClasses.disabled}`]: {
            opacity: 1,
            backgroundColor: 'rgb(225, 226, 233) !important',
          },
        },
      },
    },
  },
});

export default theme;
